import { useContext } from 'react';
import { storeContext } from '../storage';

export const useStorageConfirmTranslateContext = () => useContext(storeContext);
